import { useField } from 'formik';
import { FC, useMemo } from 'react';

import Form from '@controls/Form';

import { FILTER_COLLAPSED_ITEMS_COUNT } from '@scripts/constants';

import { filterTitleStyles, showAllButtonStyles } from '../../../../../../styles';
import { ExtendedFacetItem } from '../../../../../../types';
import { getFieldName } from '../../../../../../utils';
import { sortFilterItems } from '../../../../../../utils/sortFilterItems';
import CheckboxSearch from '../../../../../CheckboxSearch';
import { containerStyles, getBrandContainerStyles } from './styles';

interface BrandFilterItemProps {
    filterField: ExtendedFacetItem;
    fieldPrefix: string;
    formKey: string;
    showAllBrands: boolean;
    onToggleShowAll: () => void;
    onFilterChange?: (fieldName: string, newValue?: (string | number)[]) => void;
}

const BrandFilterItem: FC<BrandFilterItemProps> = ({
    filterField,
    fieldPrefix,
    formKey,
    showAllBrands,
    onToggleShowAll,
    onFilterChange,
}) => {
    const brandItems = filterField.values || [];
    const fieldName = getFieldName(String(filterField.code), fieldPrefix);
    const [field] = useField<(string | number)[]>(fieldName);

    const sortedBrandItems = useMemo(() => {
        const selectedValues = field.value || [];

        return sortFilterItems(brandItems, selectedValues);
    }, [brandItems, field.value]);

    const displayedBrands = showAllBrands ? sortedBrandItems : sortedBrandItems.slice(0, FILTER_COLLAPSED_ITEMS_COUNT);

    return (
        <div css={containerStyles}>
            <div css={filterTitleStyles}>Бренд</div>
            <div css={getBrandContainerStyles(showAllBrands)}>
                <Form.Field name={fieldName}>
                    <CheckboxSearch
                        items={displayedBrands}
                        withSearch={showAllBrands}
                        formKey={formKey}
                        onFilterChange={(changedFieldName, newValue) => {
                            const valueToPass = newValue !== undefined ? newValue : field.value || [];
                            onFilterChange?.(changedFieldName, valueToPass);
                        }}
                    />
                </Form.Field>
            </div>
            {sortedBrandItems.length > FILTER_COLLAPSED_ITEMS_COUNT && (
                <button type="button" onClick={onToggleShowAll} css={showAllButtonStyles}>
                    {showAllBrands ? 'Скрыть' : 'Показать все'}
                </button>
            )}
        </div>
    );
};

export default BrandFilterItem;
